import React from 'react';

export const DocumentsHero = () => (
  <div className="relative overflow-hidden w-full h-32 bg-white border border-slate-200 rounded-xl flex items-center justify-between">
    <div className="pl-8 z-20">
      <h1 className="font-serif font-medium text-3xl text-slate-900 tracking-wide">Verve Documents</h1>
      <p className="text-sm font-body text-slate-400 mt-2 font-medium">Secure document storage & collaboration</p>
    </div>
    <div className="w-[50%] h-full relative overflow-hidden flex-shrink-0">
      <div className="absolute inset-0 bg-gradient-to-r from-white via-white/70 to-transparent z-10 w-48" />
      <img
        src="/kitchens/5.jpg"
        alt="Document Management"
        className="absolute top-0 right-0 w-full h-full object-cover object-center"
      />
    </div>
  </div>
);
